
<v-card v-if="items.length > 0" class="upload-panel" elevation="8">
    <div class="upload-head">
        <v-icon small :color="counts.failed > 0 && counts.active === 0 ? 'error' : 'primary'" class="mr-2">
            {{ counts.active > 0 ? 'mdi-upload' : counts.failed > 0 ? 'mdi-alert-circle' : 'mdi-check-circle' }}
        </v-icon>
        <div class="upload-title">{{ title }}</div>
        <v-btn icon x-small @click="expanded = !expanded">
            <v-icon small>{{ expanded ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
        </v-btn>
        <v-btn icon x-small class="ml-1" :disabled="counts.active > 0" @click="onClose">
            <v-icon small>mdi-close</v-icon>
        </v-btn>
    </div>

    <v-progress-linear
        :value     = "overall"
        :color     = "counts.failed > 0 ? 'warning' : 'primary'"
        height     = "4"
    />

    <div v-if="expanded" class="upload-body">
        <div v-for="item in uploading" :key="item.key" class="upload-item">
            <div class="upload-name">{{ item.file.name }}</div>
            <div class="upload-where">{{ item.siteLabel }} / {{ item.folderLabel }}</div>
            <v-progress-linear :value="item.progress * 100" height="6" color="primary" rounded />
        </div>

        <div v-if="counts.active > 0" class="upload-summary">
            <span v-if="waiting > 0">{{ $t('img.upload.waiting', { n: waiting }) }}</span>
            <span v-if="processing > 0">{{ $t('img.upload.processing', { n: processing }) }}</span>
        </div>

        <div v-for="item in failed" :key="item.key" class="upload-item">
            <div class="upload-name error--text">{{ item.file.name }}</div>
            <div class="upload-where">
                {{ item.siteLabel }} / {{ item.folderLabel }} · {{ reason(item) }}
                <a v-if="retryable(item)" class="ml-1" @click="Uploads.retry(item)">{{ $t('img.upload.retry') }}</a>
            </div>
        </div>
    </div>
</v-card>
